import { sampleSize, filter } from "lodash";

import { CONTENT_TAGS_TYPES } from "../constants";

export default function selectContentTag(videoDetails) {
  const tagsOfTypeTopic = filter(
    videoDetails?.contentTags,
    (tag) => tag.type === CONTENT_TAGS_TYPES.TOPIC_CONTENT_TAG,
  );

  const tagsOfTypeActivity = filter(
    videoDetails?.contentTags,
    (tag) => tag.type === CONTENT_TAGS_TYPES.ACTIVITY_TYPE_CONTENT_TAG,
  );

  // use Activity Type tag as a fallback
  const [randomContentTag] = sampleSize(
    tagsOfTypeTopic.length > 0 ? tagsOfTypeTopic : tagsOfTypeActivity,
    1,
  );

  return randomContentTag;
}
